import { Box, Card, CardContent, Skeleton } from "@mui/material";

const UserInfoCardSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: "8%",
          pb: "4%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "2vw",
          }}
        >
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="text" width={100} height={24} sx={{ bgcolor: "rgba(255,255,255,0.35)" }} />
        </Box>
        <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: "rgba(255,255,255,0.35)" }} />
      </Box>

      <Card
        sx={{
          borderRadius: "8px",
          boxShadow: "0 4px 50px rgba(0, 0, 0, 0.05)",
          overflow: "visible",
        }}
      >
        <CardContent
          sx={{
            px: 2,
            py: 3,
            "&:last-child": {
              pb: 3,
            },
          }}
        >
          {/* Header Section */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" width="60%" height={24} />
              </Box>

              {/* Progress Bar */}
              <Skeleton variant="rectangular" width="100%" height={12} sx={{ borderRadius: 6, mb: 1.5 }} />

              <Skeleton variant="text" width="90%" height={16} />
              <Skeleton variant="text" width="70%" height={16} />
            </Box>

            {/* Trust Score Circle */}
            <Skeleton variant="circular" width={60} height={60} sx={{ flexShrink: 0, mt: -1 }} />
          </Box>

          {/* Bottom Stats Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              mt: 2,
            }}
          >
            <Box sx={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Skeleton variant="text" width={40} height={32} />
              <Skeleton variant="text" width={60} height={20} />
            </Box>
            <Box sx={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Skeleton variant="text" width={40} height={32} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default UserInfoCardSkeleton;
